<template>
  <div class="container">
    <div class="blur" @click="close"></div>
    <!-- <transition name="fade"> -->
    <div class="modal">
      <Icon class="close" @click="close">close</Icon>
      <h1 class="header">Welcome to Otonomi!</h1>

      <div class="details">
        <p class="light-text">
          We sent a verification link to your email<br />
          Please check your email and follow the link to verify your account!
        </p>

        <div
          title=""
          style="
            width: 180px;
            height: 166px;
            overflow: hidden;
            margin: 0px auto;
            outline: none;
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 188 188"
            width="118"
            height="118"
            preserveAspectRatio="xMidYMid meet"
            style="
              width: 100%;
              height: 100%;
              transform: translate3d(0px, 0px, 0px);
            "
          >
            <defs>
              <clipPath id="__lottie_element_2">
                <rect width="188" height="188" x="0" y="0"></rect>
              </clipPath>
              <linearGradient
                id="__lottie_element_12"
                spreadMethod="pad"
                gradientUnits="userSpaceOnUse"
                x1="0"
                y1="100.35800170898438"
                x2="0"
                y2="148.52999877929688"
              >
                <stop
                  offset="0%"
                  stop-color="rgb(255,255,255)"
                  stop-opacity="0"
                ></stop>
                <stop
                  offset="50%"
                  stop-color="rgb(255,255,255)"
                  stop-opacity="0.5"
                ></stop>
                <stop
                  offset="100%"
                  stop-color="rgb(255,255,255)"
                  stop-opacity="1"
                ></stop>
              </linearGradient>
            </defs>
            <g clip-path="url(#__lottie_element_2)">
              <g
                transform="matrix(1,0,0,1,94,94)"
                opacity="1"
                style="display: block"
              >
                <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                  <path
                    fill="rgb(88,65,216)"
                    fill-opacity="1"
                    d=" M90,-34.51499938964844 C90,-34.51499938964844 -90,-34.51499938964844 -90,-34.51499938964844 C-90,-34.51499938964844 0.5,17 0.5,17 C0.5,17 90,-34.51499938964844 90,-34.51499938964844z"
                  ></path>
                </g>
              </g>
              <g
                transform="matrix(1,0,0,-1.100000023841858,93.46900177001953,21.987998962402344)"
                opacity="1"
                style="display: block"
              >
                <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                  <path
                    fill="rgb(88,65,216)"
                    fill-opacity="1"
                    d=" M-90,-34.54399871826172 C-90,-34.54399871826172 90,-34.54399871826172 90,-34.54399871826172 C90,-34.54399871826172 18.80900001525879,8.722000122070312 18.80900001525879,8.722000122070312 C18.80900001525879,8.722000122070312 5.218999862670898,16.975000381469727 5.218999862670898,16.975000381469727 C1.9789999723434448,18.96299934387207 -1.934999942779541,18.96299934387207 -5.175000190734863,16.975000381469727 C-5.175000190734863,16.975000381469727 -90,-34.54399871826172 -90,-34.54399871826172z"
                  ></path>
                </g>
              </g>
              <g
                transform="matrix(1,0,0,1,94,97)"
                opacity="1"
                style="display: block"
              >
                <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                  <path
                    fill="rgb(237,237,252)"
                    fill-opacity="1"
                    d=" M72,-2.1410000324249268 C72,-2.1410000324249268 72,-68.58699798583984 72,-68.58699798583984 C72,-70.83899688720703 70.17400360107422,-72.66500091552734 67.9219970703125,-72.66500091552734 C67.9219970703125,-72.66500091552734 -67.9219970703125,-72.66500091552734 -67.9219970703125,-72.66500091552734 C-70.17400360107422,-72.66500091552734 -72,-70.83899688720703 -72,-68.58699798583984 C-72,-68.58699798583984 -72,-1.7510000467300415 -72,-1.7510000467300415 C-72,-0.3499999940395355 -71.2760009765625,0.9559999704360962 -70.08999633789062,1.7029999494552612 C-2.8329999446868896,44.05799865722656 4.23199987411499,46.73400115966797 70.23200225830078,1.2209999561309814 C71.33499908447266,0.46000000834465027 72,-0.8009999990463257 72,-2.1410000324249268z"
                  ></path>
                </g>
              </g>
              <g
                transform="matrix(1,0,0,1,94,94)"
                opacity="1"
                style="display: block"
              >
                <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                  <path
                    fill="rgb(237,237,252)"
                    fill-opacity="1"
                    d=" M7.064000129699707,4.454999923706055 C7.064000129699707,4.454999923706055 14.444000244140625,8.550000190734863 14.444000244140625,8.550000190734863 C14.444000244140625,8.550000190734863 71.9990005493164,-24.2549991607666 71.9990005493164,-24.2549991607666 C71.9990005493164,-24.2549991607666 71.9990005493164,-26.05500030517578 71.9990005493164,-26.05500030517578 C71.9990005493164,-26.05500030517578 7.064000129699707,4.454999923706055 7.064000129699707,4.454999923706055z"
                  ></path>
                </g>
                <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                  <path
                    fill="rgb(237,237,252)"
                    fill-opacity="1"
                    d=" M-72,-24.2549991607666 C-72,-24.2549991607666 -14.444999694824219,8.550000190734863 -14.444999694824219,8.550000190734863 C-14.444999694824219,8.550000190734863 -7.065000057220459,4.454999923706055 -7.065000057220459,4.454999923706055 C-7.065000057220459,4.454999923706055 -72,-26.05500030517578 -72,-26.05500030517578 C-72,-26.05500030517578 -72,-24.2549991607666 -72,-24.2549991607666z"
                  ></path>
                </g>
                <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                  <path
                    fill="rgb(138,122,227)"
                    fill-opacity="1"
                    d=" M14.444999694824219,8.550000190734863 C14.444999694824219,8.550000190734863 7.019999980926514,4.454999923706055 7.019999980926514,4.454999923706055 C7.019999980926514,4.454999923706055 5.175000190734863,3.4200000762939453 5.175000190734863,3.4200000762939453 C4.949999809265137,3.3299999237060547 4.769999980926514,3.194999933242798 4.545000076293945,3.1050000190734863 C1.440000057220459,1.6649999618530273 -2.2049999237060547,1.7549999952316284 -5.264999866485596,3.4200000762939453 C-5.264999866485596,3.4200000762939453 -90,50.084999084472656 -90,50.084999084472656 C-90,50.084999084472656 -89.91000366210938,50.26499938964844 -89.91000366210938,50.26499938964844 C-89.91000366210938,50.26499938964844 -5.130000114440918,3.6449999809265137 -5.130000114440918,3.6449999809265137 C-1.934999942779541,1.8899999856948853 1.8899999856948853,1.8899999856948853 5.085000038146973,3.6449999809265137 C5.085000038146973,3.6449999809265137 89.91000366210938,50.26499938964844 89.91000366210938,50.26499938964844 C89.91000366210938,50.26499938964844 90,50.084999084472656 90,50.084999084472656 C90,50.084999084472656 14.444999694824219,8.550000190734863 14.444999694824219,8.550000190734863z"
                  ></path>
                </g>
                <g opacity="0.8" transform="matrix(1,0,0,1,0,0)">
                  <path
                    fill="url(#__lottie_element_12)"
                    fill-opacity="1"
                    d=" M14.444999694824219,8.550000190734863 C14.444999694824219,8.550000190734863 7.019999980926514,4.454999923706055 7.019999980926514,4.454999923706055 C7.019999980926514,4.454999923706055 5.175000190734863,3.4200000762939453 5.175000190734863,3.4200000762939453 C4.949999809265137,3.3299999237060547 4.769999980926514,3.194999933242798 4.545000076293945,3.1050000190734863 C1.440000057220459,1.6649999618530273 -2.2049999237060547,1.7549999952316284 -5.264999866485596,3.4200000762939453 C-5.264999866485596,3.4200000762939453 -90,50.084999084472656 -90,50.084999084472656 C-90,50.084999084472656 -89.91000366210938,50.26499938964844 -89.91000366210938,50.26499938964844 C-89.91000366210938,50.26499938964844 -5.130000114440918,3.6449999809265137 -5.130000114440918,3.6449999809265137 C-1.934999942779541,1.8899999856948853 1.8899999856948853,1.8899999856948853 5.085000038146973,3.6449999809265137 C5.085000038146973,3.6449999809265137 89.91000366210938,50.26499938964844 89.91000366210938,50.26499938964844 C89.91000366210938,50.26499938964844 90,50.084999084472656 90,50.084999084472656 C90,50.084999084472656 14.444999694824219,8.550000190734863 14.444999694824219,8.550000190734863z"
                  ></path>
                </g>
                <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                  <path
                    fill="rgb(194,194,215)"
                    fill-opacity="1"
                    d=" M7.064000129699707,4.454999923706055 C7.064000129699707,4.454999923706055 14.444000244140625,8.550000190734863 14.444000244140625,8.550000190734863 C14.444000244140625,8.550000190734863 71.9990005493164,-24.2549991607666 71.9990005493164,-24.2549991607666 C71.9990005493164,-24.2549991607666 71.9990005493164,-26.05500030517578 71.9990005493164,-26.05500030517578 C71.9990005493164,-26.05500030517578 7.064000129699707,4.454999923706055 7.064000129699707,4.454999923706055z"
                  ></path>
                </g>
                <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                  <path
                    fill="rgb(194,194,215)"
                    fill-opacity="1"
                    d=" M-72,-24.2549991607666 C-72,-24.2549991607666 -14.444999694824219,8.550000190734863 -14.444999694824219,8.550000190734863 C-14.444999694824219,8.550000190734863 -7.065000057220459,4.454999923706055 -7.065000057220459,4.454999923706055 C-7.065000057220459,4.454999923706055 -72,-26.05500030517578 -72,-26.05500030517578 C-72,-26.05500030517578 -72,-24.2549991607666 -72,-24.2549991607666z"
                  ></path>
                </g>
                <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                  <path
                    fill="rgb(138,122,227)"
                    fill-opacity="1"
                    d=" M5.085000038146973,3.6449999809265137 C1.8899999856948853,1.8899999856948853 -1.934999942779541,1.8899999856948853 -5.130000114440918,3.6449999809265137 C-5.130000114440918,3.6449999809265137 -89.91000366210938,50.26499938964844 -89.91000366210938,50.26499938964844 C-89.91000366210938,50.26499938964844 -90,50.084999084472656 -90,50.084999084472656 C-90,50.084999084472656 -5.21999979019165,3.4649999141693115 -5.21999979019165,3.4649999141693115 C-2.1600000858306885,1.7999999523162842 1.440000057220459,1.7100000381469727 4.590000152587891,3.1500000953674316 C1.4850000143051147,1.7100000381469727 -2.1600000858306885,1.7999999523162842 -5.21999979019165,3.4649999141693115 C-5.21999979019165,3.4649999141693115 -7.065000057220459,4.5 -7.065000057220459,4.5 C-7.065000057220459,4.5 -14.489999771118164,8.595000267028809 -14.489999771118164,8.595000267028809 C-14.489999771118164,8.595000267028809 -90,50.084999084472656 -90,50.084999084472656 C-90,50.084999084472656 -90,68.08499908447266 -90,68.08499908447266 C-90,74.29499816894531 -86.08499908447266,79.6050033569336 -80.55000305175781,81.62999725341797 C-80.0999984741211,81.80999755859375 -79.6500015258789,81.94499969482422 -79.19999694824219,82.03500366210938 C-78.30000305175781,82.26000213623047 -77.30999755859375,82.44000244140625 -76.31999969482422,82.48500061035156 C-76.09500122070312,82.48500061035156 -75.82499694824219,82.48500061035156 -75.5999984741211,82.48500061035156 C-75.5999984741211,82.48500061035156 -72,82.48500061035156 -72,82.48500061035156 C-72,82.48500061035156 72,82.48500061035156 72,82.48500061035156 C72,82.48500061035156 75.5999984741211,82.48500061035156 75.5999984741211,82.48500061035156 C77.3550033569336,82.48500061035156 79.0199966430664,82.16999816894531 80.55000305175781,81.62999725341797 C86.08499908447266,79.6050033569336 90,74.29499816894531 90,68.08499908447266 C90,68.08499908447266 90,50.084999084472656 90,50.084999084472656 C90,50.084999084472656 89.91000366210938,50.26499938964844 89.91000366210938,50.26499938964844 C89.91000366210938,50.26499938964844 5.085000038146973,3.6449999809265137 5.085000038146973,3.6449999809265137z"
                  ></path>
                </g>
                <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                  <path
                    fill="rgb(121,103,224)"
                    fill-opacity="1"
                    d=" M-14.444999694824219,8.550000190734863 C-14.444999694824219,8.550000190734863 -72,-24.2549991607666 -72,-24.2549991607666 C-72,-24.2549991607666 -90,-34.51499938964844 -90,-34.51499938964844 C-90,-34.51499938964844 -90,50.084999084472656 -90,50.084999084472656 C-90,50.084999084472656 -14.444999694824219,8.550000190734863 -14.444999694824219,8.550000190734863z"
                  ></path>
                </g>
                <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                  <path
                    fill="rgb(121,103,224)"
                    fill-opacity="1"
                    d=" M72,-24.2549991607666 C72,-24.2549991607666 14.444999694824219,8.550000190734863 14.444999694824219,8.550000190734863 C14.444999694824219,8.550000190734863 90,50.084999084472656 90,50.084999084472656 C90,50.084999084472656 90,-34.51499938964844 90,-34.51499938964844 C90,-34.51499938964844 72,-24.2549991607666 72,-24.2549991607666z"
                  ></path>
                </g>
              </g>
              <g
                transform="matrix(1,0,0,0.6216871738433838,94,80.94821166992188)"
                opacity="1"
                style="display: none"
              >
                <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                  <path
                    fill="rgb(88,65,216)"
                    fill-opacity="1"
                    d=" M-90,-34.54399871826172 C-90,-34.54399871826172 90,-34.54399871826172 90,-34.54399871826172 C90,-34.54399871826172 18.80900001525879,8.722000122070312 18.80900001525879,8.722000122070312 C18.80900001525879,8.722000122070312 5.218999862670898,16.975000381469727 5.218999862670898,16.975000381469727 C1.9789999723434448,18.96299934387207 -1.934999942779541,18.96299934387207 -5.175000190734863,16.975000381469727 C-5.175000190734863,16.975000381469727 -90,-34.54399871826172 -90,-34.54399871826172z"
                  ></path>
                </g>
              </g>
              <g
                style="display: none"
                transform="matrix(1,0,0,1,94,94.5)"
                opacity="1"
              >
                <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                  <path
                    fill="rgb(88,65,216)"
                    fill-opacity="1"
                    d=" M-90,-34.54399871826172 C-90,-34.54399871826172 90,-34.54399871826172 90,-34.54399871826172 C90,-34.54399871826172 18.80900001525879,8.722000122070312 18.80900001525879,8.722000122070312 C18.80900001525879,8.722000122070312 5.218999862670898,16.975000381469727 5.218999862670898,16.975000381469727 C1.9789999723434448,18.96299934387207 -1.934999942779541,18.96299934387207 -5.175000190734863,16.975000381469727 C-5.175000190734863,16.975000381469727 -90,-34.54399871826172 -90,-34.54399871826172z"
                  ></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <!-- </transition> -->
  </div>
</template>
<script >
import { defineComponent, ref, computed, onMounted } from "vue"
import { useRoute } from "vue-router"
import Icon from "./Icon.vue"
import Button from "./Button.vue"
import axios from "axios"
import { useGtag } from "vue-gtag-next"

const apiurl = "https://api.otonomi.no"
// const apiurl = "http://localhost:8085"

export default defineComponent({
  components: { Icon, Button },
  props: {},

  setup(props, { emit }) {
    const route = useRoute()
    const { event } = useGtag()

    const close = (event) => {
      emit("close")
    }
    const email = ref("")
    const password = ref("")
    console.log(route.path)

    const validemail = computed(() => {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email.value).toLowerCase())
    })

    const captcha = ref("")
    let captchatoken = ""
    const captchavalue = ref("")
    function getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
      })
    }
    const getcaptcha = () => {
      axios({
        baseURL: "https://auth.otonomi.no",
        url: "/captcha",
        method: "get",

        responseType: "arraybuffer",
      })
        .then((res) => {
          captchatoken = res.headers.authorization
          captcha.value = Buffer.from(res.data, "binary").toString("base64")
        })
        .catch((err) => {
          console.log(err)
        })
    }
    onMounted(() => {
      getcaptcha()
    })

    const subscribe = () => {
      if (validemail.value == true) {
        event("Subscribe", {
          event_category: "engagement",
          event_label: "method",
        })

        axios({
          baseURL: "http://localhost:8090",
          url: "/register",
          method: "post",
          data: {
            email: email.value,
            password: password.value,
            token: captchatoken,
            value: captchavalue.value,
          },
        })
          .then((res) => {
            console.log(res)
          })
          .catch((err) => {
            console.log(err)
          })
        // emit("close")
      }
    }

    const subscribe2 = () => {
      if (validemail.value == true) {
        event("Subscribe", {
          event_category: "engagement",
          event_label: "method",
        })

        axios({
          baseURL: apiurl,
          url: "/subscribe",
          method: "post",
          data: {
            email: email.value,
            password: password.value,
            origin: "otonomi-platform",
            path: route.path,
          },
        })
          .then((res) => {
            return
          })
          .catch((err) => {
            console.log(err)
          })
        emit("close")
      }
    }

    return {
      close,
      email,
      password,
      subscribe,
      validemail,
      captcha,
      captchavalue,
    }
  },
})
</script>
<style lang="scss" scoped>
@import "../css/home.scss";

.material-icons {
  display: flex;
}
.bottom-spacing {
  margin-bottom: 50px;
}
.container {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.password {
  height: 0px;
  opacity: 0;
  display: none;
}
.fade-enter-active {
  transition: opacity 1s;
}
.fade-enter-from .modal {
  opacity: 0;
}
.fade-enter-to .modal {
  opacity: 1;
}
.fade-enter-active .modal {
  transition: opacity 500ms 500ms;
}
.fade-enter-from .blur {
  opacity: 0;
  backdrop-filter: blur(0px);
}
.fade-enter-to .blur {
  opacity: 1;
  backdrop-filter: blur(6px);
}
.fade-enter-active .blur {
  transition: backdrop-filter 500ms;
}
</style>
